(() => {
  const initSlider = (sectionSteps) => {
    const pagination = sectionSteps.querySelector(".product_pagination");

    const setPaginationCSSVariable = (slides) => {
      if (pagination) {
        const totalSlides = slides.slides.length;
        const slidesPerView = slides.params.slidesPerView;
        const paginationBullets = Math.ceil(totalSlides / slidesPerView);
        pagination.style.setProperty("--slides-count", paginationBullets);
      }
    };

    if (sectionSteps) {
      let swiperParams = {
        slidesPerView: 1,
        scrollbar: {
          el: pagination,
          draggable: true,
          spanOnRelease: true,
        },
        breakpoints: {
          990: {
            slidesPerView: 3
          },
          750: {
            slidesPerView: 2
          },
        },
        on: {
          init: function () {
            setPaginationCSSVariable(this);
          },
          resize: function () {
            setPaginationCSSVariable(this);
          },
        },
      };

      stepsSwiper = new Swiper(sectionSteps, swiperParams);
    }
  };

  const initSection = (section) => {
    let sectionSteps = section.querySelector(".products");

    if (sectionSteps) {
      initSlider(sectionSteps);
    }
  };

  initSection(document);

  document.addEventListener("shopify:section:load", function (section) {
    initSection(section.target);
  });
})();
